import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import ChangePasswordPopUp from './components/ChangePasswordPopUp';
import { HIDE_FORCE_CHANGE_PASSWORD_MODAL } from './actions';
import { resetPasswordExpiredToast } from '../utils/snackbarUtils';

const PasswordCreator = ({ open, onClose, responseData }) => {
  const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);

  useEffect(() => {
    if (open) {
      setShowChangePasswordForm(false);
    }
  }, [open]);

  if (open && !showChangePasswordForm) {
    return (
      <Dialog open={open} maxWidth='xs' fullWidth className='password-info-modal'>
        <DialogContent>
          <Typography>Your password has expired. Please change your password</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowChangePasswordForm(true)} color='primary' variant='contained'>
            Change Password
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return (
    <ChangePasswordPopUp open={open && showChangePasswordForm} onClose={onClose} responseData={responseData} />
  )
}

const mapStateToProps = state => ({
  open: state.shareReducer.forceChangePasswordModal,
  responseData: state.shareReducer.forceChangePasswordModalData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: () => {
      resetPasswordExpiredToast();
      dispatch({
        type: HIDE_FORCE_CHANGE_PASSWORD_MODAL,
      })
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordCreator);
